import { useFragment } from 'react-relay';
import { performanceOverviewNumbersFragment } from './PerformanceOverviewNumbers.relay';
import { NumbersGroup } from './lib/numbersGroup';
import type { PerformanceOverviewNumbersPropsType } from './types';

const PerformanceOverviewNumbers: React.FC<PerformanceOverviewNumbersPropsType> = (props) => {
  const data = useFragment(performanceOverviewNumbersFragment, props.data);

  return (
    <div className={props.className}>
      <NumbersGroup
        className="performanceWrapper"
        labelText={data.currentperformancetext}
        labelPaText={data.paperformancetext}
        value={props.currentperformance}
        paValue={props.paperformance}
        id={1}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        language={props.language}
      />

      {!Number.isNaN(props.currentbenchmark) && Number.isFinite(props.currentbenchmark) ? (
        <NumbersGroup
          className="benchmarkWrapper"
          labelText={data.currentbenchmarktext}
          labelPaText={data.pabenchmarktext}
          value={props.currentbenchmark}
          paValue={props.pabenchmark}
          id={2}
          onMouseEnter={props.onMouseEnter}
          onMouseLeave={props.onMouseLeave}
          language={props.language}
        />
      ) : null}
    </div>
  );
};

export { PerformanceOverviewNumbers };
